import { render, staticRenderFns } from "./EnterpriseInquiryForm.vue?vue&type=template&id=23d63cf7&scoped=true"
import script from "./EnterpriseInquiryForm.vue?vue&type=script&lang=js"
export * from "./EnterpriseInquiryForm.vue?vue&type=script&lang=js"
import style0 from "./EnterpriseInquiryForm.vue?vue&type=style&index=0&id=23d63cf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d63cf7",
  null
  
)

export default component.exports